export default __webpack_public_path__ + "static/media/spaces_in_mumbai_256.a7e1e0a7.jpg";